module.exports = __webpack_public_path__ + "lp/img/vote_verybad_active.eebfe173.svg";